export default "__VITE_ASSET__Dm_PW3zh__"